import { Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import { useAuthCheck } from "../hooks/useAuthCheck";
import {
  Home,
  Reporting,
  Desktop,
  Solutions,
  Integrations,
  Portal,
  Roadmap,
  Feedback,
  Sweepstakes,
  Investments,
  OAuthCallback,
  AutomationServices,
  RoboticAutomation,
  WorkflowAutomation,
  OutageHub,
  Troubleshooting,
  ProjectExecution,
  AgnosticKnowledge,
  Onboarding,
} from "./lazyRoutes";
import DashboardLayout from "../layouts/dashboard-layout/DashboardLayout";

export default function Router() {
  const { isLoading, component } = useAuthCheck();

  if (isLoading || component) {
    return component;
  }

  const routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/reporting", element: <Reporting /> },
    { path: "/desktop", element: <Desktop /> },
    { path: "/solutions", element: <Solutions /> },

    { path: "/solutions/automation-services", element: <AutomationServices /> },
    { path: "/solutions/robotic-automation", element: <RoboticAutomation /> },
    { path: "/solutions/workflow-automation", element: <WorkflowAutomation /> },
    { path: "/solutions/outage-hub", element: <OutageHub /> },
    { path: "/solutions/troubleshooting", element: <Troubleshooting /> },
    { path: "/solutions/project-execution", element: <ProjectExecution /> },
    { path: "/solutions/agnostic-knowledge", element: <AgnosticKnowledge /> },
    { path: "/solutions/onboarding", element: <Onboarding /> },

    { path: "/integrations", element: <Integrations /> },
    { path: "/portal", element: <Portal /> },
    { path: "/roadmap", element: <Roadmap /> },
    { path: "/feedback", element: <Feedback /> },
    { path: "/sweepstakes", element: <Sweepstakes /> },
    { path: "/investments", element: <Investments /> },
    { path: "/oauth/callback", element: <OAuthCallback /> },
    { path: "*", element: <Navigate to="/" replace /> },
  ]);

  return (
    <DashboardLayout>
      <Suspense fallback={<div>Loading...</div>}>{routes}</Suspense>
    </DashboardLayout>
  );
}
